import { useEffect, useState } from "react";
import { getMyPermissions } from "../api/salonPermissions";
import { useAuth } from "../context/AuthContext";

export default function useMyPermissions({ enabled = true } = {}) {
  const { token, user } = useAuth();
  const storedSalonId =
    typeof window !== "undefined"
      ? Number(window.localStorage.getItem("salon_id")) || null
      : null;
  const salonId = user?.salon_id ?? storedSalonId ?? null;
  const [permissions, setPermissions] = useState(null);
  const [errorStatus, setErrorStatus] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!enabled || !token || !salonId) {
      setPermissions(null);
      setErrorStatus(null);
      setLoading(false);
      return undefined;
    }

    let isActive = true;
    setLoading(true);
    setErrorStatus(null);
    getMyPermissions(token)
      .then((bundle) => {
        if (!isActive) return;
        const effective =
          bundle?.effective && typeof bundle.effective === "object"
            ? bundle.effective
            : {};
        setPermissions(effective);
        setErrorStatus(null);
      })
      .catch((err) => {
        if (!isActive) return;
        const status = err?.status ?? err?.response?.status ?? null;
        setErrorStatus(status);
        setPermissions(status === 401 ? null : {});
      })
      .finally(() => {
        if (!isActive) return;
        setLoading(false);
      });

    return () => {
      isActive = false;
    };
  }, [enabled, token, salonId]);

  return { permissions, loading, errorStatus };
}
